import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV2'
import { CssBaseline, ThemeProvider } from '@mui/material'
import { ApolloProvider } from '@apollo/client'

import { theme } from 'theme/theme'
import apolloClient from 'configs/apolloClient'
import { AppRouter } from 'AppRouter'
import { AuthProvider } from 'utils/auth'
import { Toast } from 'utils/toast'

const App = () => (
  <ThemeProvider theme={theme}>
    <ApolloProvider client={apolloClient}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <AuthProvider>
          <CssBaseline />
          <AppRouter />
        </AuthProvider>
      </LocalizationProvider>
    </ApolloProvider>

    <Toast />
  </ThemeProvider>
)

export default App
